import './title.styles.scss';

interface TitleProps {
  title: string;
}
export default function Title({ title }: TitleProps) {
  return <h1 className="title-component">{title}</h1>;
}
